<div class="inline-search-wrapper" (click)="addToInlineSearchProps({value:selectedItemIds})"></div>


<div class="sem-listing-items-container">

  <!-- Loading state -->
  @if (isLoading) {
    <div class="sem-listing-loading">
      <span>Nalaganje podatkov...</span>
      <div class="loading-spinner"></div>
    </div>
  }

  <!-- Error state -->
  @if (hasError && !isLoading) {
    <div class="sem-listing-error">
      <span>{{errorApiMsg}}</span>
    </div>
  }

  <!-- Individual Items -->
  @for (item of items; track $index) {
    <div class="sem-listing-item" [hidden]="isLoading">
      <label class="sem-listing-item-label">
        <input
          type="checkbox"
          class="sem-listing-checkbox"
          [checked]="isItemSelected(item)"
          (click)="onItemCheckboxChange(item, !isItemSelected(item))"
          [value]="item.Id" />
          <span class="sem-listing-item-title">{{item.Title}}</span>
        </label>
      </div>
    }

    <!-- Empty state -->
    @if (!hasError && (!items || (items.length === 0 && !isLoading))) {
      <div class="sem-listing-empty">
        <span>{{emptyMessage}}</span>
      </div>
    }

  </div>